(function (angular) {
	'use strict';

	angular
		.module('recurringInvestmentAgreementsModule')
		.controller('RecurringInvestmentAgreements', [
			'SettingsFactory',
			RecurringInvestmentAgreementsFunction
		]);

	function RecurringInvestmentAgreementsFunction(
		SettingsFactory
	) {

		var recurringInvestmentAgreements = this;

		recurringInvestmentAgreements.$onInit = function() {
			SettingsFactory.recurringInvestment.getAgreements()
				.then(function(response) {
					recurringInvestmentAgreements.formReady = true;
					recurringInvestmentAgreements.acknowledgments = response;
				})
				.catch(function() {
					recurringInvestmentAgreements.acknowledgementForm.$setValidity('documentLoadError', false);
				});
		};
	}
})(window.angular);